import React, { useContext } from 'react'
import { DarkModeContext } from '../../../global/Theme';
import { ThemeSwitcher } from '../Button'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import MobileNotification from '../../common/MobileNotification'


export default function MobileNav() {
    const isNotificationActive = useSelector(state => state.navbarState.notification)
    const { isDark } = useContext(DarkModeContext);
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const navigateToNotification = () => {
        history.push('/notification')
        dispatch({
            type: 'UPDATE_NAV', payload: {
                notification: true,
                home: false,
                search: false,
                post: false,
                chat: false,
                profile: false
            }
        })
    }

    const handleLogoClick = () => {
        if (location.pathname !== '/home') {
            history.push('/home')
        }else{
           window.scrollTo({top: 0, behavior: 'smooth'});

        }
    }

    const notification = useSelector(state => state.notification)

    return (
        <div id="mobileWrapper" className={isDark ? 'mobileWrapperDark' : 'mobileWapperLight'}>
            <div id="mobileNav" className={isDark ? 'mobileNavDark' : null}>
                {notification.isEnabled && <MobileNotification text={notification.text} icon={notification.icon} />}
                <div id="mobileNavLeft">
                    <ThemeSwitcher />
                </div>
                <div id="mobileNavCenter">
                    <img onClick={handleLogoClick} id="logo" src={require('../../../assets/img/lovrlogo.png')} />

                </div>
                <div id="mobileNavRight">
                    <img onClick={navigateToNotification} src={isNotificationActive ? require('../../../assets/icons/notifications_a.svg') : require('../../../assets/icons/notifications.svg')} />
                </div>
            </div>
        </div>
    )
}
